// Folders for the contract TEMPLATES library (14 Oct 2026, Jacob: "folders so it's not as messy for
// AU, NZ, USA, (No personal guarantee folder) — all documents stored for that country or that term
// removed"). A template is in at most ONE folder; none = "Unfiled". The list is fixed here so the
// API validates against the same keys the library renders — adding a folder is one line below.
//
// 22 Oct 2026, Jacob: "we should have a non guarantor but it should be a separate tab where you can
// choose AU, USA, or NZ" — the one No personal guarantee folder had every country's no-guarantee set in
// it (24 templates in one list, "very overwhelming"). So the no-guarantee side is now one folder PER
// COUNTRY, and the library shows them as ONE tab with an AU / NZ / USA switch inside it. The Australian
// one keeps its original key, so nothing already filed moves and no migration is needed.
export const TEMPLATE_FOLDERS = [
    { key: 'AU', label: 'AU', region: 'AU', noGuarantee: false },
    { key: 'NZ', label: 'NZ', region: 'NZ', noGuarantee: false },
    { key: 'USA', label: 'USA', region: 'USA', noGuarantee: false },
    { key: 'NO_PERSONAL_GUARANTEE', label: 'No personal guarantee · AU', region: 'AU', noGuarantee: true },
    { key: 'NO_PERSONAL_GUARANTEE_NZ', label: 'No personal guarantee · NZ', region: 'NZ', noGuarantee: true },
    { key: 'NO_PERSONAL_GUARANTEE_USA', label: 'No personal guarantee · USA', region: 'USA', noGuarantee: true },
    // 23 Oct 2026, Jacob: "another version of the contract as a section which is (No Lock in) — RT Application and
    // Placement confirmation / DDR". One Australian-market folder holding both documents; not a country switch.
    { key: 'NO_LOCK_IN', label: 'No lock-in', region: 'AU', noGuarantee: false },
    // 26 Oct 2026, Jacob: "add another section called 2 week notice (no lock in)" — the same two documents with a two-week
    // notice period instead of a lock-in. Same shape as No lock-in: one Australian-market folder, no migration.
    { key: 'TWO_WEEK_NOTICE', label: '2 week notice (no lock in)', region: 'AU', noGuarantee: false },
];
export const TEMPLATE_FOLDER_KEYS = TEMPLATE_FOLDERS.map((f) => f.key);
export function isTemplateFolder(v) {
    return typeof v === 'string' && TEMPLATE_FOLDER_KEYS.includes(v);
}
/** The whole no-guarantee side of the library, every country at once — what its tab shows by default. */
export const NO_GUARANTEE_TAB = 'NO_GUARANTEE';
export function isFolderSelection(v) {
    return v === 'ALL' || v === 'UNFILED' || v === NO_GUARANTEE_TAB || isTemplateFolder(v);
}
/** The three folders of the no-guarantee tab, in AU / NZ / USA order. */
export const NO_GUARANTEE_FOLDERS = TEMPLATE_FOLDERS.filter((f) => f.noGuarantee);
export function isNoGuaranteeFolder(k) {
    return isTemplateFolder(k) && TEMPLATE_FOLDERS.find((f) => f.key === k).noGuarantee;
}
/** The no-guarantee folder for a country (Australia's keeps the original key). */
export function noGuaranteeFolder(region) {
    return NO_GUARANTEE_FOLDERS.find((f) => f.region === region).key;
}
/** Which country a folder belongs to. */
export function folderRegion(k) {
    return TEMPLATE_FOLDERS.find((f) => f.key === k).region;
}
/** A stored value that is not (or is no longer) a known folder counts as unfiled — never hidden. */
export function folderOf(t) {
    return isTemplateFolder(t.folder) ? t.folder : null;
}
export function filterByFolder(templates, sel) {
    if (sel === 'ALL')
        return [...templates];
    if (sel === 'UNFILED')
        return templates.filter((t) => folderOf(t) === null);
    if (sel === NO_GUARANTEE_TAB)
        return templates.filter((t) => isNoGuaranteeFolder(folderOf(t)));
    return templates.filter((t) => folderOf(t) === sel);
}
// ── Which market a template is for (19 Oct 2026, Josh: "do the rt hub side" of the USA contract) ──
//
// ⛔ The USA folders are the USA's; EVERY other folder — AU, NZ (New Zealand clients are in the Australian
// market), the Australian and NZ no-guarantee folders — and Unfiled is Australia's. So every template that
// exists today stays Australian, and a document becomes a USA one only by being filed in a USA folder
// (with or without the guarantee). A personal draft carries no folder of its own: judge it by the shared
// template it was copied from.
export function templateMarket(t) {
    const k = folderOf(t);
    return k !== null && folderRegion(k) === 'USA' ? 'USA' : 'AUS';
}
/** May a template filed like this be sent to a lead in `market`? Only its own market's. */
export function templateFitsMarket(t, market) {
    return templateMarket(t) === (market === 'USA' ? 'USA' : 'AUS');
}
/** The refusal shown when a BDM (or the API) tries to cross markets; null when it fits. */
export function templateMarketMismatch(t, market) {
    if (templateFitsMarket(t, market))
        return null;
    return templateMarket(t) === 'USA'
        ? 'This is a USA contract and this deal is Australian. Choose an Australian template.'
        : 'This deal is in the USA. Choose a contract from the USA folder.';
}
/** Counts per chip: `ALL`, `UNFILED`, the no-guarantee tab as a whole, and every folder (zero included,
 *  so empty folders still show). */
export function folderCounts(templates) {
    const out = { ALL: templates.length, UNFILED: 0, [NO_GUARANTEE_TAB]: 0 };
    for (const f of TEMPLATE_FOLDERS)
        out[f.key] = 0;
    for (const t of templates) {
        const k = folderOf(t);
        if (k === null)
            out.UNFILED += 1;
        else {
            out[k] += 1;
            if (isNoGuaranteeFolder(k))
                out[NO_GUARANTEE_TAB] += 1;
        }
    }
    return out;
}
//# sourceMappingURL=templateFolders.js.map